/** A same-origin path the login redirect may follow. Rejects absolute URLs and protocol-relative paths. */
export function safeNextPath(raw: string | null | undefined): string | null {
  if (!raw) return null
  let path = raw
  try {
    path = decodeURIComponent(raw)
  } catch {
    return null
  }
  if (!path.startsWith('/') || path.startsWith('//') || path.includes('\\') || path.includes('://')) return null
  return path
}
